<template>
  <div>
    <PaginaTitulo
      sticky
      titulo="MONITORAMENTO"
      subTitulo="Gerencie e monitore os seus produtos"
    ></PaginaTitulo>
    <div class="container conteudo-principal monitoria-container">
      <!-- <div class="cabecalho">
      <h1>
        <span>MONITORAMENTO</span>
        <span class="subtitulo ">Gerencie e monitore os seus produtos</span>
      </h1>
    </div> -->

      <div v-if="blLoadingButton">
        <LoadingPadraoContainer
          :fraseLoading="[
            'Carregando Histórico',
            'Aguarde um momento',
            'Consultando banco de dados'
          ]"
          classe="azul"
          :delay="'7000'"
        />
      </div>
      <FiltrosMonitoria
        v-if="!blLoadingButton && getEmpresa.id"
        :conteudo="arProduto"
        :data_de="form.de"
        :data_ate="form.ate"
        @produtosFiltradosAtualizados="atualizarProdutosFiltrados"
        @filtrarDatas="recebeFiltrarDatas"
      />
      <TabelaPaginada
        v-if="
          !blLoadingButton && getEmpresa.id && produtosFiltrados.length > 0 && arProduto.length > 0
        "
        :conteudo="produtosFiltrados"
      ></TabelaPaginada>
      <div
        v-show="
          (arProduto.length == 0 && getEmpresa.id && !blLoadingButton) ||
            (produtosFiltrados.length == 0 && !blLoadingButton)
        "
      >
        <div class="text-center sem-vinculo-monitoria ">
          Nenhum resultado de monitoramento encontrado.
        </div>
      </div>
      <div v-if="!getEmpresa.id" class="text-center sem-vinculo-monitoria">
        Selecione uma empresa para exibir as alterações dos produtos monitorados.
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Api from "@/services/api.js";
import FiltrosMonitoria from "../FiltrosMonitoria/FiltrosMonitoria.vue";
import TabelaPaginada from "../TabelaPaginada/TabelaPaginada.vue";
import ModalRelatorio from "../ModalRelatorio/ModalRelatorio.vue";
import PaginaTitulo from "@/components/PaginaTitulo/PaginaTitulo.vue";
import LoadingPadraoContainer from "@/components/LoadingPadrao/LoadingPadraoContainer.vue";

export default {
  name: "HistoricoAlteracoes",
  props: {},
  components: {
    FiltrosMonitoria,
    TabelaPaginada,
    ModalRelatorio,
    PaginaTitulo,
    LoadingPadraoContainer
  },
  data() {
    return {
      produtoSelecionado: "",
      form: {
        produto: "",
        de: "",
        ate: "",
        uf: "",
        ncm: "",
        tributo: "",
        id_arquivo: "",
        cest: ""
      },
      acesso_simulado: localStorage.getItem("token_simulacao") ? true : false,
      blLoadingButton: true,
      arProduto: [],
      produtosFiltrados: [],
      produtosMonitorados: ""
    };
  },
  created() {
    if (this.$route.params.id !== undefined && this.$route.params.id !== "") {
      this.form.produto = parseInt(this.$route.params.id);
      this.obterMudancas(this.form);
      this.produtoSelecionado = this.form.produto;
    } else {
      this.listarProdutos();
    }
  },

  mounted() {},
  watch: {
    getEmpresa(newVal, oldVal) {
      if (newVal.id != oldVal.id) {
        this.listarProdutos();
      }
    }
  },
  computed: {
    ...mapGetters("empresa", ["getEmpresa"]),
    ...mapGetters("usuario", ["getUsuario"])
  },

  methods: {
    atualizarProdutosFiltrados(produtosFiltrados) {
      this.produtosFiltrados = produtosFiltrados;
    },
    recebeFiltrarDatas(form) {
      this.form.de = form.de;
      this.form.ate = form.ate;
      this.obterMudancas(form);
    },
    listarProdutos: function() {
      this.blLoadingButton = true;
      if (!this.getEmpresa.id) {
        this.blLoadingButton = false;
        return false;
      }
      new Api()
        .get("Produto/obterProdutosMonitoria/" + this.getEmpresa.id + "/" + 500 + "/" + 1)
        .then(response => {
          let arProduto = response.dados;
          arProduto = arProduto.filter(p => {
            return p.monitoria.length > 0 || p.icms_estado.length > 0;
          });
          let arProdutosCadastro = arProduto.filter(p => {
            return p.ncme != null && p.ncme.descricao != null && p.ncme.descricao.vigente == 1;
          });

          this.produtosMonitorados = arProdutosCadastro.map(p => {
            return p.id;
          });

          let form = {
            produto: this.produtosMonitorados,
            de: "",
            ate: "",
            uf: "",
            ncm: "",
            tributo: "",
            cest: ""
          };

          this.obterMudancas(form);

          if (arProdutosCadastro.length == 0) {
            that.blLoadingButton = false;
          }
        });
    },

    obterMudancas: function(form) {
      this.blLoadingButton = true;
      new Api().post("Mudanca/obterMudancas/" + this.getEmpresa.id, form).then(response => {
        this.arProduto = [];
        this.produtosFiltrados = [];
        if (response.dados.length > 0) {
          response.dados.forEach(mudanca => {
            this.arProduto.push(mudanca);
            this.produtosFiltrados.push(mudanca);
          });
        }
        this.blLoadingButton = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.cabecalho {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.animated-button:hover {
  animation: pulse 1s infinite linear;
}
.monitoria-container {
  margin-top: 10px;
}
</style>
